var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile_container tile",on:{"click":_vm.showCategoryModels}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.categoryIcon}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.category.label.toUpperCase()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }